import { createSlice } from "@reduxjs/toolkit";
import axios from "../../shared/api/axios";

// ----------------------------------------------------------------------

const initialState = {
  games: [],
  errorMessage: null,
};

const slice = createSlice({
  name: "gameHistory",
  initialState,
  reducers: {
    getGameHistory(state, action) {
      state.games = action.payload.receipts;
    },
    setError(state, action) {
      state.errorMessage = action.payload;
    },
  },
});

// Reducer
export default slice.reducer;

// ----------------------------------------------------------------------
export function getGamesHistory() {
  return async (dispatch) => {
    try {
      const response = await axios.get("/api/v1/keno/last-games/");
      dispatch(slice.actions.getGameHistory(response.data));
    } catch (error) {
      const errorMessage =
        error?.response?.data?.detail ||
        error?.response?.data?.errorMessage ||
        error?.message;
      dispatch(slice.actions.setError(errorMessage));
    }
  };
}
